export const iconFontAwesomeNatureBug = (
	<i className="fa-solid fa-bug"></i>
);
